import { yupResolver } from '@hookform/resolvers/yup';
import React from 'react';
// components
import { FormProvider, useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { DialogContent, DialogActions, Grid } from '@mui/material';
import { withStyles } from '@mui/styles';

import { TextFieldBase } from '../../components/inputs/TextFieldBase';
import { withFormController } from '../../components/hocs/forms';
import CBButton from '../../components/Buttons/CbButton';
import { qualysConnect } from './ConnectorService';
import { PubSub } from '../../utils/eventUtils';
import { CONNECTOR_TYPES } from './connectors.constants';
import useNotifications from '../../_lib/notifications/useNotifications';

// helpers

const TextField = withFormController(TextFieldBase);
const schema = Yup.object().shape({
  username: Yup.string().required('API User is required'),
  password: Yup.string().required('Password is required'),
});

const QualysForm = ({ classes, close, data }: any) => {
  const { cbid, connectorType } = data;
  const notifications = useNotifications();
  const defaultValues = {
    username: '',
    password: '',
  };

  const { handleSubmit, ...methods } = useForm({
    defaultValues,
    resolver: yupResolver(schema),
  });
  const {
    formState: { isSubmitting },
  } = methods;

  const onSubmit = (formData: any) => {
    const payload = formData;
    const modifiedPayload = {
      connector: connectorType ?? CONNECTOR_TYPES.QUALYSVM,
      provider: 'COWBELL',
      credentials: {
        username: payload.username,
        password: payload.password,
      },
      cbid,
      metadata: null,
    };
    return qualysConnect({}, modifiedPayload)
      .then(() => {
        close();
        PubSub.publish('connector-page-refetch', true);
      })
      .catch(() => {
        notifications.error('Failed to connect, please try again later');
      });
  };

  const handleCancel = () => {
    close();
  };

  return (
    <section className={classes.cardContentContainer}>
      <FormProvider {...methods} handleSubmit={handleSubmit}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogContent classes={{ root: classes.container }}>
            <Grid
              container
              justifyContent="left"
              className={classes.inputFields}
            >
              <Grid item md={10}>
                <TextField
                  name="username"
                  label="API User"
                  fullWidth
                  required
                />
              </Grid>
              <Grid item md={10}>
                <TextField
                  name="password"
                  label="Password"
                  type="password"
                  fullWidth
                  required
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <CBButton action={handleCancel} styleName="cancel">
              Cancel
            </CBButton>
            <CBButton
              type="submit"
              loading={isSubmitting}
              disabled={isSubmitting}
              styleName="ctaButton"
              buttonText="Connect"
            />
          </DialogActions>
        </form>
      </FormProvider>
    </section>
  );
};

const styles = ({ palette }: any) => {
  return {
    description: {
      fontSize: '1.167rem',
      color: palette.primary.main,
      lineHeight: 1.5,
      fontStyle: 'italic',
      textAlign: 'center',
      margin: '0 0 2rem 0 !important',
    },
    container: {
      flex: '1 1 auto',
      padding: '0 5rem 0.5rem 5rem',
      'overflow-y': 'visible',
    },
    inputFields: {
      justifyContent: 'space-around',
    },
  };
};

// @ts-expect-error TS(2345): Argument of type '({ palette }: any) => { descript... Remove this comment to see the full error message
const StyledQualysForm = withStyles(styles)(QualysForm);

export default StyledQualysForm;

export const QualysFormConfig = {
  QualysForm: {
    component: StyledQualysForm,
    config: {
      title: 'Enter Access Credentials',
      maxWidth: 'md',
    },
  },
};
